/*
  PDP V2 Product Details + page helpers. Opening and closing is done by Broadcast's
  <collapsible-elements>; this file only
  - mirrors each row's state to aria-expanded on its <summary>, and
  - forwards the "Size Chart & Fit Guide" row to the size-chart app's own button
    (hiding the row when the app offers no chart on this product), and
  - publishes the buy-box column (left edge, width) as CSS variables on desktop so the
    lower sections can line up with it (joy-pdp-page.css).
*/
(function () {
  if (window.joyProductDetailsReady) return;
  window.joyProductDetailsReady = true;

  var ROOT = '[data-joy-details]';
  var CHART_TRIGGER = '[data-mp-sc-root] [role="button"], #Avada-SC-button [role="button"]';

  function syncExpanded(root) {
    root.querySelectorAll('[data-collapsible]').forEach(function (row) {
      var head = row.querySelector('[data-collapsible-trigger]');
      if (head) head.setAttribute('aria-expanded', row.getAttribute('open') === 'true' ? 'true' : 'false');
    });
  }

  document.addEventListener('theme:collapsible:toggle', function (event) {
    var root = event.target.closest && event.target.closest(ROOT);
    if (!root) return;
    syncExpanded(root);
    // the row that was open closes one frame later
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        syncExpanded(root);
      });
    });
  });

  document.addEventListener('click', function (event) {
    var row = event.target.closest && event.target.closest(ROOT + ' [data-joy-size-chart]');
    if (!row) return;
    var trigger = document.querySelector(CHART_TRIGGER);
    if (trigger) trigger.click();
  });

  // The size-chart app injects its button after load; give it time before hiding the row.
  function checkChart(attempt) {
    var rows = document.querySelectorAll(ROOT + ' [data-joy-size-chart]');
    if (!rows.length) return;
    if (document.querySelector(CHART_TRIGGER)) {
      rows.forEach(function (row) { row.hidden = false; });
      return;
    }
    if (attempt >= 8) {
      rows.forEach(function (row) { row.hidden = true; });
      return;
    }
    window.setTimeout(function () { checkChart(attempt + 1); }, 1000);
  }

  // Desktop: lower sections share the buy-box column of the main product section.
  function syncColumn() {
    var root = document.documentElement;
    var col = document.querySelector('[data-section-type="product"] .form__width') || document.querySelector('.product__content .form__width');
    if (!col || window.innerWidth < 750) {
      root.removeAttribute('data-joy-col');
      return;
    }
    var rect = col.getBoundingClientRect();
    if (!rect.width) return;
    root.style.setProperty('--joy-col-left', Math.round(rect.left + window.pageXOffset) + 'px');
    root.style.setProperty('--joy-col-width', Math.round(rect.width) + 'px');
    root.setAttribute('data-joy-col', '');
  }

  function start() {
    checkChart(0);
    syncColumn();
    window.addEventListener('resize', syncColumn);
    window.addEventListener('load', syncColumn);
    // the column also moves when the layout changes without a window resize event
    if (window.ResizeObserver) new window.ResizeObserver(syncColumn).observe(document.documentElement);
    if (window.matchMedia) {
      var desktop = window.matchMedia('(min-width: 750px)');
      if (desktop.addEventListener) desktop.addEventListener('change', syncColumn);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
